import React from 'react'
import Footer from './layout/Footer'
import Header from './layout/Header'
import { Helmet } from "react-helmet"


export default function Layout({children}) {
  return (
    <div className='flex flex-col max-w-screen text-base min-h-screen h-auto relative'>
       <Helmet>
          <title>Promaco || Ferreplomería</title>
          <link rel="canonical" href="http://promaco.com/" /> 
          <meta charSet="utf-8" />
       </Helmet>
        <Header/>
        {children}
        <Footer/>
    </div>
  )
}